import ProjectCreate from './ProjectCreate';

export default ProjectCreate;


// WEBPACK FOOTER //
// ./resources/assets/js/components/ProjectCreate/index.js